const TENANT_STORAGE_KEY = 'tenant_slug'

export function getTenantSlugFromHost(hostname: string): string | null {
  if (!hostname) return null
  const host = hostname.toLowerCase()
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') {
    return null
  }
  const parts = host.split('.').filter(Boolean)
  if (parts.length >= 3) {
    return parts[0]
  }
  if (parts.length >= 2 && parts[parts.length - 1] === 'localhost') {
    return parts[0]
  }
  return null
}

export function resolveTenantSlug(): string | null {
  if (typeof window === 'undefined') return null
  const envSlug = import.meta.env.VITE_TENANT_SLUG
  if (envSlug && typeof envSlug === 'string' && envSlug.trim()) {
    return envSlug.trim()
  }
  const hostSlug = getTenantSlugFromHost(window.location.hostname)
  if (hostSlug) return hostSlug
  const stored = window.localStorage.getItem(TENANT_STORAGE_KEY)
  if (stored && stored.trim()) return stored.trim()
  return null
}

export function storeTenantSlug(slug: string): void {
  if (typeof window === 'undefined') return
  if (!slug) return
  window.localStorage.setItem(TENANT_STORAGE_KEY, slug)
}
